// extracted by mini-css-extract-plugin
export default {"onboardingSettings":"GmExXFTEykMgAbkBTEnh","title":"T8QM8hTREgGlm8VKo7pP","description":"DGS8lF8l9GC5NSQQmQFl"};